import React, { useState } from 'react';

export default function ProjectSingleImage({ title, time, description, imageSrc, imageCaption }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="max-w-2xl mx-auto mb-12 p-6 border rounded-lg shadow-md bg-white">
      {/* Title */}
      <h2 className="text-2xl font-bold text-gray-800">{title}</h2>

      {/* Time */}
      <h3 className="text-md font-medium text-gray-500 mb-2">{time}</h3>

      {/* Description */}
      <p className="text-gray-600 mb-4">{description}</p>

      {/* Image container with bottom-left caption */}
      <div className="relative cursor-pointer" onClick={() => setIsOpen(true)}>
        {/* Image */}
        <img
          src={imageSrc}
          alt={title}
          className="rounded-lg shadow object-cover w-full h-auto"
        />

        {/* Caption at bottom-left */}
        <div className="absolute bottom-2 left-2 bg-black bg-opacity-60 text-white px-3 py-1 rounded text-sm z-10">
          {imageCaption}
        </div>
      </div>

      {/* Modal */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
          onClick={() => setIsOpen(false)}
        >
          <img
            src={imageSrc}
            alt={title}
            className="max-w-full max-h-full rounded"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}

